var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29191 13.3334H2.38025C1.70358 13.3334 1.14941 12.7909 1.14941 12.1259V3.46921C1.14941 1.94087 2.28691 1.24671 3.68108 1.92921L6.27108 3.20087C6.83108 3.47504 7.29191 4.20421 7.29191 4.82254V13.3334Z",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8162 9.28504V11.49C12.8162 12.75 12.2328 13.3334 10.9728 13.3334H7.29199V6.57837L7.56616 6.6367L10.1912 7.22587L11.3753 7.48837C12.1453 7.65754 12.7753 8.0542 12.8103 9.1742C12.8162 9.2092 12.8162 9.2442 12.8162 9.28504Z",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20801 5.75H5.23217",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20801 8.08337H5.23217",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1904 7.22588V9.10422C10.1904 9.82755 9.60126 10.4167 8.87793 10.4167C8.1546 10.4167 7.56543 9.82755 7.56543 9.10422V6.63672L10.1904 7.22588Z",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8096 9.17429C12.7746 9.86262 12.2029 10.4168 11.5029 10.4168C10.7796 10.4168 10.1904 9.82762 10.1904 9.10429V7.22595L11.3746 7.48845C12.1446 7.65762 12.7746 8.05429 12.8096 9.17429Z",
    stroke: "#7D7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuilding);
export default __webpack_public_path__ + "static/media/ic-building.7fc8b2ab84d29e66ecaa6976c0fd2811.svg";
export { ForwardRef as ReactComponent };